import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { MessagingUserInterface } from '~/messaging/interfaces/user.interface';
import { TalkService } from '~/messaging/services/talk.service';

@Component({
  selector: 'app-messaging-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.scss'],
})
export class MessagingInboxComponent implements OnInit, OnDestroy {
  @Input() public recipient?: MessagingUserInterface;

  @ViewChild('talkjsContainer') public talkjsContainer!: ElementRef;

  private subscription$: Subscription;

  constructor(private readonly talkService: TalkService) {}

  public ngOnDestroy(): void {
    this.subscription$?.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscription$ = this.createInbox().subscribe();
  }

  private createInbox(): Observable<void> {
    return this.talkService.createCurrentSession().pipe(
      mergeMap((session) =>
        this.talkService.createInbox(session, this.recipient)
      ),
      mergeMap((inbox) => inbox.mount(this.talkjsContainer.nativeElement))
    );
  }
}
